
{
  "title": "探索服務",
  "searchPlaceholder": "搜尋服務...",
  "sortBy": "排序方式",
  "sortOptions": {
    "featured": "精選",
    "rating": "評分最高",
    "reviews": "評價最多",
    "nameAsc": "名稱 A-Z",
    "nameDesc": "名稱 Z-A"
  },
  "filters": {
    "category": "類別",
    "location": "位置",
    "rating": "評分",
    "clearAll": "清除全部"
  },
  "providers": {
    "loading": "載入服務提供者中...",
    "providerCount": "找到 {{count}} 個服務提供者",
    "provider": "服務提供者",
    "loadMore": "載入更多",
    "searchResults": "「{{query}}」的搜尋結果",
    "categoryResults": "{{category}} 服務",
    "favoriteResults": "您收藏的服務提供者",
    "noResults": {
      "title": "未找到服務提供者",
      "description": "嘗試調整您的搜尋或篩選條件以找到您要找的內容。"
    }
  }
}
